export default "__VITE_ASSET__1b7cc528__"